var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-toast",
    {
      staticClass: "resend-confirmation-toast",
      attrs: { message: _vm.message }
    },
    [
      _c("div", {
        staticClass: "toast-body",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("confirmation.resent", { mail: _vm.message.mail })
          )
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }